import { render, staticRenderFns } from "./newsAdd.vue?vue&type=template&id=f4872042"
import script from "./newsAdd.vue?vue&type=script&lang=js"
export * from "./newsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4872042')) {
      api.createRecord('f4872042', component.options)
    } else {
      api.reload('f4872042', component.options)
    }
    module.hot.accept("./newsAdd.vue?vue&type=template&id=f4872042", function () {
      api.rerender('f4872042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/newsSet/newsAdd.vue"
export default component.exports